import '../styles/Header.css'
import {motion} from 'framer-motion'
import Socials from './Socials'
import Experience from './Experience'
import { fadeIn, slideIn } from '../utils/variants';
function Header() {
    return (
        <div className='header-container'>

            <Socials />
            <div className="header">
                <motion.div
                    variants={fadeIn("left", 0.2)}
                    initial="hidden"
                    whileInView={"show"}
                    viewport={{ once: true, amount: 0.1 }}
                    className="dev-photo">
                    </motion.div>

    
                <header>
                    <motion.div
                        variants={slideIn("up", 0.2)}
                        initial="hidden"
                        whileInView={"show"}
                        viewport={{ once: true, amount: 0.1 }}>
                        <div className="heading-intro">
                            <p>Nice to meet you!

                                <br />
                                I'm <span className='fullname'>Kojo Antwi Osei-Sarfo</span>
                            </p>
                        </div>
                        <div className="dev-bio">
                            <p>Based in Accra, Ghana I am a full stack developer that loves to build accessible web apps that users love</p>
                        </div>
                        <a href="#contact-section">CONTACT ME</a>
                    </motion.div>
                </header>
            </div>
            <motion.div
                variants={fadeIn("right", 0.1)}
                initial="hidden"
                whileInView={"show"}
                viewport={{ once: true, amount: 0.1 }}>
                <Experience />
            </motion.div>
        </div>
    );
}
export default Header;